import axios from "axios";
import camelcaseKeys from 'camelcase-keys';
import snakecaseKeys from 'snakecase-keys';
import _ from 'helpers/no_conflict_lodash';
import { clickAsLink } from 'helpers/link_helpers';

import { setGroupFilterIds } from './query';
import { retrieveRecords } from './search';
import { changeSelectedProperties } from './select_list';
import { toggleAlert } from './ui';
import { post } from 'helpers/api';

export const ADD_GROUP = 'ADD_GROUP';
export function addGroup(group) {
  return {
    group,
    type: ADD_GROUP
  };
}

export const END_EDIT_GROUPS = 'END_EDIT_GROUPS';
export function endEditGroups() {
  return { type: END_EDIT_GROUPS };
}

export const END_BULK_DELETE = 'END_BULK_DELETE';
export function endBulkDelete() {
  return { type: END_BULK_DELETE };
}

export const CHANGE_GROUPS = 'CHANGE_GROUPS';
export function changeGroups(groups) {
  return {
    groups,
    type: CHANGE_GROUPS
  };
}

export const START_BULK_DELETE = 'START_BULK_DELETE';
export function startBulkDelete() {
  return { type: START_BULK_DELETE };
}

export const START_BULK_TAGGING = 'START_BULK_TAGGING';
export function startBulkTagging() {
  return { type: START_BULK_TAGGING };
}

export const START_EDIT_GROUPS = 'START_EDIT_GROUPS';
export function startEditGroups(groups) {
  return {
    groups,
    type: START_EDIT_GROUPS
  };
}

export const START_DELETE_GROUPS = 'START_DELETE_GROUPS';
export function startDeleteGroups(group) {
  return {
    group,
    type: START_DELETE_GROUPS
  };
}

export const END_BULK_TAGGING = 'END_BULK_TAGGING';
export function endBulkTagging() {
  return { type: END_BULK_TAGGING };
}

export const END_DELETE_GROUPS = 'END_DELETE_GROUPS';
export function endDeleteGroups() {
  return { type: END_DELETE_GROUPS };
}

export const SET_BULK_TAGS = 'PEOPLE-SET_BULK_TAGS';
export function setBulkTags(tags) {
  return { tags, type: SET_BULK_TAGS };
}

export const SHOW_MOVE_RECORDS_MODAL = 'SHOW_MOVE_RECORDS_MODAL';
export function showMoveRecordsModal() {
  return { type: SHOW_MOVE_RECORDS_MODAL };
}

export const HIDE_MOVE_RECORDS_MODAL = 'HIDE_MOVE_RECORDS_MODAL';
export function hideMoveRecordsModal() {
  return { type: HIDE_MOVE_RECORDS_MODAL };
}

export const SHOW_COPY_RECORDS_MODAL = 'SHOW_COPY_RECORDS_MODAL';
export function showCopyRecordsModal() {
  return { type: SHOW_COPY_RECORDS_MODAL };
}

export const HIDE_COPY_RECORDS_MODAL = 'HIDE_COPY_RECORDS_MODAL';
export function hideCopyRecordsModal() {
  return { type: HIDE_COPY_RECORDS_MODAL };
}

export function bulkDelete() {
  return (dispatch, getState) => {
    const deletePath = getState().paths.bulkDelete;
    const propertiesIds = getState().selectList.selectedPropertyIds;

    post(deletePath, { propertyIds: propertiesIds }).then(({ message, error }) => {
      dispatch(endBulkDelete());
      dispatch(retrieveRecords());
      dispatch(toggleAlert(message, error));
      dispatch(changeSelectedProperties([]));
    });
  };
}

export function bulkTagging(tags, propertyIds) {
  return (dispatch, getState) => (
    axios.put(getState().paths.tags.bulkTagging, {
      tags: tags,
      property_ids: propertyIds,
    }).then((response) => {
      if (response.status == 200) {
        const text = propertyIds.length > 1 ? " Properties were Tagged" : " Property was Tagged";
        dispatch(toggleAlert(propertyIds.length + text, false));
      } else {
        const text = propertyIds.length > 1 ? " Properties weren't Tagged" : " Property was not Tagged";
        dispatch(toggleAlert(propertyIds.length + text, true));
      }
    }));
}

export function deleteFromGroup(group, ids) {
  return (dispatch) => {
    return axios.patch(
      group.deleteMembersUrl,
      {
        member_ids: ids
      }
    ).then(() => {
      dispatch(retrieveGroups());
    });
  };
}

export function addToGroup(group, ids) {
  return (dispatch) => {
    return axios.patch(
      group.url,
      {
        member_ids: ids
      }
    ).then(() => dispatch(retrieveGroups()));
  };
}

export function createGroup(group, ids) {
  return (dispatch, getState) => {
    const { id, ...groupAttributes } = snakecaseKeys(group);

    return axios.post(
      getState().paths.groups,
      {
        research_group: groupAttributes,
        member_ids: ids
      }
    ).then((response) => {
      dispatch(addGroup(camelcaseKeys(response.data.group)));
      dispatch(endEditGroups());
      dispatch(setGroupFilterIds([response.data.group.id]));
      dispatch(retrieveRecords());
      return response.data.group;
    });
  };
}

export function deleteGroups(groups) {
  return (dispatch) => {
    const requests = groups.map(group => axios.delete(group.url));
    return Promise.all(requests).then(() => {
      dispatch(endDeleteGroups());
      dispatch(retrieveGroups());
    });
  };
}

export function updateGroups(groups) {
  return (dispatch) => {
    const requests = groups.map((group) => {
      const { url, ...groupAttributes } = snakecaseKeys(group);
      return axios.patch(url, { research_group: groupAttributes });
    });

    return Promise.all(requests).then(() => {
      dispatch(endEditGroups());
      dispatch(retrieveGroups());
    });
  };
}

export function newGroup() {
  return startEditGroups([{
    id: null,
    name: ''
  }]);
}

export function retrieveGroups() {
  return (dispatch, getState) => (
    axios.get(getState().paths.groups).then(response => (
      dispatch(changeGroups(_.map(response.data.groups, group => camelcaseKeys(group))))
    ))
  );
}

export function goToPropertyShow(clickEvent, property) {
  return (_, getState) => {
    const allPropertiesIds = getState().search.meta.propertyIds;

    const offset = allPropertiesIds.findIndex(num => num == property.id);
    const href = `${property.showPath}?offset=${offset}`;

    if (property.showPath && href) {
      clickAsLink(window, href, clickEvent);
    }
  };
}